"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FindAPI = void 0;
const base_1 = require("../base");
class FindAPI extends base_1.BaseAPI {
    /**
     * The find method makes it easy to search for objects in our database by an external id.
     * This method will search all objects (movies, TV shows and people) and return the results in a
     * single response.
     *
     * @returns Promise<FindResponse>
     * @see https://developers.themoviedb.org/3/find/find-by-id
     */
    async find(externalId, filters) {
        const path = this.getPath(`/find/${externalId}`, filters);
        return this.get(path);
    }
}
exports.FindAPI = FindAPI;
